export const SET_USER_REPSITE_DATA= "SET_USER_REPSITE_DATA";
export const SET_USER_CONFIGURATION_DATA= "SET_USER_CONFIGURATION_DATA";
export const SET_CREATE_STREAM_DATA= "SET_CREATE_STREAM_DATA";
export const SET_TOKEN_DATA= "SET_TOKEN_DATA";
export const SET_JOIN_DATA= "SET_JOIN_DATA";
export const SET_JOIN_ATTENDEEID_DATA= "SET_JOIN_ATTENDEEID_DATA";
export const SET_ATTENDEE_TOKEN= "SET_ATTENDEE_TOKEN";
export const SET_RTM_TOKEN= "SET_RTM_TOKEN";
export const SET_HOST_TIME= "SET_HOST_TIME";
export const SET_HOST_SECONDS= "SET_HOST_SECONDS";
export const SET_PERSON_NUM= "SET_PERSON_NUM";
export const SET_ATTENDEE_LIST= "SET_ATTENDEE_LIST";
export const SET_ALL_ATTENDEE_LIST= "SET_ALL_ATTENDEE_LIST";
export const SET_STREAM_STATE= "SET_STREAM_STATE";
export const SET_PRESENTER_NUM= "SET_PRESENTER_NUM";
export const SET_STREAM_WIDTH= "SET_STREAM_WIDTH";
export const SET_STREAM_HEIGHT= "SET_STREAM_HEIGHT";
export const SET_SLOW_NETWORK= "SET_SLOW_NETWORK";
export const SET_INFO_DATA= "SET_INFO_DATA";
export const SET_HOST_CONNECTION_STATUS= "SET_HOST_CONNECTION_STATUS";